// PartnerInCareSection.js
import React from 'react';

const PartnerInCareSection = () => {
  return (
    <section className="bg-white py-20 md:py-28">
      <div className="max-w-3xl mx-auto px-6 text-center">
        <p className="text-primary text-xs md:text-sm font-medium tracking-[0.22em] uppercase mb-6">
          Your Partner in Care
        </p>
        <h2 className="font-display font-light text-ink leading-[1.1] text-3xl md:text-4xl lg:text-5xl mb-6">
          Supporting Every Part<br className="hidden md:block" /> of the Care Journey
        </h2>
        <p className="text-muted text-base md:text-lg leading-relaxed max-w-xl mx-auto">
          Whether you’re receiving care, providing care, or managing services, we’re here for you.
        </p>
      </div>
    </section>
  );
};

export default PartnerInCareSection;
